//Class to validate regular expressions

export default function (value, regex) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return new RegExp(regex).test(value)
}
